var _path;
import * as React from "react";
function SvgBarsSortDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.286 27.715a1.285 1.285 0 00-.909 2.194l7.714 7.714a1.285 1.285 0 001.818 0l7.714-7.714a1.285 1.285 0 10-1.817-1.818l-5.52 5.52V3.285A1.29 1.29 0 0020 2c-.707 0-1.286.575-1.286 1.286V33.61l-5.52-5.52a1.293 1.293 0 00-.908-.375z"
  })));
}
export default SvgBarsSortDown;